import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import { domainName, processApi } from "../../../../utility/index"
// import partsRow from "./Plugin/partsRowTable.vue";

export default {
    components: { iTable, IPagination },
    data() {
        return {
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                MaintainTime: [],
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "requestSerialNumber",
                    label: this.$t('VehicleManagement.serialNumber'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('common.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "carWorkTime",
                    label: this.$t('VehicleManagement.carWorkTime'),
                    align: "center",
                    width: "160px",
                    // render: (h, params) => {
                    //     return h('span', this.$formatTime(params.row.carWorkTime))
                    // }

                },
                {
                    prop: "contactName",
                    label: this.$t('VehicleManagement.repairPerson'),
                    align: "center",
                    width: "120px"
                },

                {
                    prop: "happenTime",
                    label: this.$t('TopBar.happenTime'),
                    align: "center",
                    width: "200px",
                    // render: (h, params) => {
                    //     return h('span', this.$formatTime(params.row.happenTime))
                    // }
                },
                {
                    prop: "phone",
                    label: this.$t('TopBar.phone'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "urgeCount",
                    label: this.$t('VehicleManagement.urgeCount'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "repairState",
                    label: this.$t('common.repairStatus'),
                    align: "center",
                    width: "120px",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.repairState === '' ? '' : params.row.repairState === 0 ? 'danger' : params.row.repairState === 1 ? 'warning' : params.row.repairState === 2 ? 'success' : 'info' }
                        }, params.row.repairState === '' ? '' : params.row.repairState === 0 ? this.$t('VehicleManagement.unaccepted') : params.row.repairState === 1 ? this.$t('VehicleManagement.repaired') : params.row.repairState === 2 ? this.$t('VehicleManagement.alreadyRepaired') : this.$t('VehicleManagement.closed'))
                    }

                }
            ],
            // dialogDetailsFormVisible: false,
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        isBtn: "REPAIRFORM_DETAIL",
                        method: (index, row) => {
                            // this.dialogDetailsFormVisible = true
                            // this.queryDetails(index, row)
                            this.$router.push({
                                path: '/VehicleManagement/RepairManagement/Details',
                                query: { requestSerialNumber: row.requestSerialNumber, tabName: 'third', sourcePage: 'maintain' }
                            })
                        }
                    }
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            // dialogFormVisible: false,
            // formLabelWidth: '112px',
            // diaTitle: '',
            // btnType: '',
            // rules: {
            //     carId: [
            //         { required: true, message: this.$t('TopBar.form.carId'), trigger: 'blur' }
            //     ],
            //     contactName: [
            //         { required: true, message: this.$t('TopBar.form.contactName'), trigger: 'blur' }
            //     ],
            //     happenTime: [
            //         { required: true, message: this.$t('TopBar.form.happenTime'), trigger: 'change' }
            //     ],
            //     phone: [
            //         { required: true, message: this.$t('TopBar.form.phone'), trigger: 'blur' }
            //     ],
            // },
            // form: {
            //     carId: '',
            //     contactName: '',
            //     happenTime: '',
            //     phone: '',
            //     remarks: '',
            //     filePath: ''
            // },
            selected: [],
            orgId: '',
            // imageUrl: '',
            // dialogVisible: false,
            // processImg: processApi,
            // FileList: [],
            // filePath: '',
            // dialogMaintainFormVisible: false,
            // MaintainForm: {
            //     requestSerialNumber: '',
            //     carId: '',
            //     operateUser: '',
            //     operateTime: '',
            //     repairType: '1',
            //     remarks: '',
            //     peopleCost: '',
            //     filePath: '',
            //     materialCost: '',
            //     Cost: ''
            // },
            // MaintainRules: {
            //     requestSerialNumber: [
            //         { required: true, message: this.$t('VehicleManagement.form.serialNumber'), trigger: 'blur' }
            //     ],
            //     carId: [
            //         { required: true, message: this.$t('TopBar.form.carId'), trigger: 'blur' }
            //     ],
            //     operateUser: [
            //         { required: true, message: this.$t('VehicleManagement.form.maintainPerson'), trigger: 'blur' }
            //     ],
            //     operateTime: [
            //         { required: true, message: this.$t('VehicleManagement.form.maintainTime'), trigger: 'change' }
            //     ],
            //     repairType: [
            //         { required: true, message: this.$t('VehicleManagement.form.chooseFaultItem'), trigger: 'change' }
            //     ],
            // },
            // selected: [],
            // DetailsRorm: {
            //     carId: '',
            //     contactName: '',
            //     happenTime: '',
            //     phone: '',
            //     remarks: '',
            //     filePath: ''
            // },
            // maintenanceDis: true,
            // reminderDis: true,
            // finishDis: true,
            // typeList: [],

            // imageMaintainUrl: '',
            // dialogMaintainVisible: false,
            // processMaintainImg: processApi,
            // FileMaintainList: [],
            // fileMaintainPath: '',
        }
    },
    // computed: {
    //     materialCost() {
    //         this.MaintainForm.materialCost = Number(this.MaintainForm.peopleCost || 0) + Number(this.MaintainForm.Cost || 0)
    //         return this.MaintainForm.materialCost
    //     },
    // },
    // watch: {
    //     materialCost(val) {
    //         console.log(val)
    //         this.MaintainForm.materialCost = val
    //     },
    // },
    methods: {
        // computedPrice(num) {
        //     console.log(num)
        //     this.MaintainForm.Cost = num
        // },
        // MaintainRepair() {
        //     this.dialogMaintainFormVisible = true
        //     this.MaintainForm.operateUser = sessionStorage.getItem("username")
        //     this.MaintainForm.operateTime = moment().format("YYYY-MM-DD HH:mm:ss")
        //     this.MaintainForm.requestSerialNumber = this.selected[0].serialNumber
        //     this.MaintainForm.carId = this.selected[0].carId
        //     this.getFaultType()
        //     this.$nextTick(() => {
        //         this.$refs.diaTable.tableData = []
        //         this.$refs.MaintainForm.clearValidate()
        //     })
        // },
        // handleMaintainPictureCardPreview(file) {
        //     this.imageMaintainUrl = file.url;
        //     this.dialogMaintainVisible = true;
        // },
        // handleMaintainRemove(file, fileList) {
        //     this.FileMaintainList = []
        //     const arr = []
        //     fileMaintainList.map((item) => {
        //         this.FileMaintainList.push({
        //             name: item.name,
        //             url: item.url,
        //             uid: item.uid
        //         })
        //         arr.push(item.url)
        //     })
        //     this.MaintainForm.filePath = arr.join(',')
        // },
        // handleMaintainAvatarSuccess(res, file) {
        //     const arr = []
        //     this.FileMaintainList.push({
        //         url: res[0],
        //     })
        //     this.FileMaintainList.map(item => {
        //         arr.push(item.url)
        //     })
        //     this.MaintainForm.filePath = arr.join(',')
        //     console.log(this.MaintainForm.filePath)
        // },
        // closeMaintainDia() {
        //     this.MaintainForm = {
        //         requestSerialNumber: '',
        //         carId: '',
        //         operateUser: '',
        //         operateTime: '',
        //         repairType: '1',
        //         remarks: '',
        //         peopleCost: '',
        //         filePath: '',
        //         materialCost: '',
        //         filePath: ''
        //     }
        //     this.$nextTick(() => {
        //         this.$refs.diaTable.tableData = []
        //     })
        //     this.dialogMaintainFormVisible = false;
        // },
        // submitMaintainForm(MaintainFormName) {
        //     this.$refs[MaintainFormName].validate((valid) => {
        //         if (valid) {
        //             let param = {
        //                 requestSerialNumber: this.MaintainForm.requestSerialNumber,
        //                 carId: this.MaintainForm.carId,
        //                 operateUser: this.MaintainForm.operateUser,
        //                 operateTime: this.MaintainForm.operateTime,
        //                 repairType: this.MaintainForm.repairType,
        //                 remarks: this.MaintainForm.remarks,
        //                 peopleCost: this.MaintainForm.peopleCost,
        //                 filePath: this.MaintainForm.filePath,
        //                 insertRepairMaterialDTOList: JSON.stringify(this.$refs.diaTable.tableData),
        //                 materialCost: this.MaintainForm.materialCost
        //             }
        //             this.$store.dispatch('MaintainManagement/GET_INSERTMAINTAIN', param).then(res => {
        //                 if (res.data.code == 200) {
        //                     this.$message.success(this.$t('common.btn.addSuccess'))
        //                     this.dialogMaintainFormVisible = false;
        //                     this.getRepairList();
        //                     this.closeMaintainDia();
        //                 } else {
        //                     this.$message.error(res.data.msg)
        //                 }

        //             }).catch(err => { })



        //         }
        //     });
        // },
        // MaintainCancle(MaintainFormName) {
        //     this.dialogMaintainFormVisible = false;
        //     this.MaintainForm = {
        //         requestSerialNumber: '',
        //         carId: '',
        //         operateUser: '',
        //         operateTime: '',
        //         repairType: '1',
        //         remarks: '',
        //         peopleCost: '',
        //         filePath: '',
        //         materialCost: '',
        //     }
        //     this.$nextTick(() => {
        //         this.$refs.diaTable.tableData = []
        //     })
        // },

        getRepairList() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.MaintainTime) {
                if (this.formInline.MaintainTime.length > 0) {
                    startTime = this.formInline.MaintainTime[0];
                    endTime = this.formInline.MaintainTime[1];
                }
            }
            let param = {
                orgId: this.orgId,
                userId: sessionStorage.getItem("userId"),
                selectType: 2,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                // contactName: this.formInline.contactName,
                startTime: startTime,
                endTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('RepairManagement/GET_GETREPAIRLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getRepairList()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                contactName: '',
                MaintainTime: [],
            }
            this.getRepairList()
        },
        // addRepair() {
        //     this.dialogFormVisible = true
        //     this.diaTitle =this.$t('common.btn.add')
        //     this.btnType = 'add'
        //     this.FileList = []
        //     this.form.contactName = sessionStorage.getItem("username")
        //     this.form.happenTime = moment().format("YYYY-MM-DD HH:mm:ss")
        //     this.$nextTick(() => {
        //         this.$refs.form.resetFields()
        //     })
        // },
        // submitForm(formName) {
        //     this.$refs[formName].validate((valid) => {
        //         if (valid) {
        //             let param = {
        //                 carId: this.form.carId,
        //                 contactName: this.form.contactName,
        //                 happenTime: this.form.happenTime,
        //                 phone: this.form.phone,
        //                 remarks: this.form.remarks,
        //                 filePath: this.form.filePath,
        //             }
        //             this.$store.dispatch('MaintainManagement/GET_INSERTREPAIR', param).then(res => {
        //                 if (res.data.code == 200) {
        //                     this.$message.success(this.$t('common.btn.addSuccess'))
        //                     this.dialogFormVisible = false;
        //                     this.getRepairList();
        //                     this.closeDia();
        //                 } else {
        //                     this.$message.error(res.data.msg)
        //                 }

        //             }).catch(err => { })
        //         }
        //     });
        // },
        // getFaultType() {
        //     this.$store.dispatch('DictionaryManaged/GET_SELECTMALFUNCTIONTYPE', {}).then(res => {
        //         if (res) {
        //             if (res.data.code == 200) {
        //                 this.typeList = res.data.data
        //             }
        //         }
        //     }).catch(err => { })
        // },

        // handlePictureCardPreview(file) {
        //     this.imageUrl = file.url;
        //     this.dialogVisible = true;
        // },
        // handleRemove(file, fileList) {
        //     this.FileList = []
        //     const arr = []
        //     fileList.map((item) => {
        //         this.FileList.push({
        //             name: item.name,
        //             url: item.url,
        //             uid: item.uid
        //         })
        //         arr.push(item.url)
        //     })
        //     this.form.filePath = arr.join(',')
        // },

        // handleAvatarSuccess(res, file) {
        //     const arr = []
        //     this.FileList.push({
        //         url: res[0],
        //     })
        //     this.FileList.map(item => {
        //         arr.push(item.url)
        //     })
        //     this.form.filePath = arr.join(',')
        // },
        // cancle(formName) {
        //     this.dialogFormVisible = false;
        //     this.form = {
        //         carId: '',
        //         contactName: '',
        //         happenTime: '',
        //         phone: '',
        //         remarks: '',
        //         filePath: ''
        //     }
        // },
        // closeDia() {
        //     this.form = {
        //         carId: '',
        //         contactName: '',
        //         happenTime: '',
        //         phone: '',
        //         remarks: '',
        //         filePath: ''
        //     }
        //     this.dialogFormVisible = false;
        // },
        deleteRepair() {
            this.$confirm(this.$t('common.AreYouSureAcceptOrder'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { requestSerialNumber: this.selected[0].requestSerialNumber, userId: sessionStorage.getItem("userId") }
                    this.$store.dispatch('RepairManagement/GET_UPDATEREPAIRUSER', param).then(response => {
                        if (response.data.code == 200) {
                            this.getRepairList()
                            this.$message.success(this.$t('common.OrderSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        // finishRepair() {
        //     this.$confirm(this.$t('VehicleManagement.form.confirmFinish'), this.$t('common.btn.hint'),
        //         {
        //             cancelButtonText: this.$t('common.btn.cancel'),
        //             confirmButtonText: this.$t('common.btn.confirm'),
        //             type: 'warning'
        //         }).then(res => {
        //             let param = { id: this.selected.map(item => item.id).join() }
        //             this.$store.dispatch('MaintainManagement/GET_FINISHREPAIR', param).then(response => {
        //                 if (response.data.code == 200) {
        //                     this.getRepairList()
        //                     this.$message.success(this.$t('VehicleManagement.form.finishSuccess'))
        //                 } else {
        //                     this.$message.error(response.data.msg)
        //                 }
        //             }).catch(error => { })
        //         }).catch(err => {

        //         })
        // },
        // queryDetails(index, row) {
        //     this.DetailsRorm = {
        //         carId: row.carId,
        //         contactName: row.contactName,
        //         happenTime: row.happenTime,
        //         phone: row.phone,
        //         remarks: row.remarks,
        //         filePath: row.filePath
        //     }
        //     this.FileList = [];
        //     const arr = row.filePath.split(',')
        //     arr.forEach(filePath => {
        //         this.FileList.push({
        //             url: filePath,
        //           });
        //     });
        // },
        handleSelectionChange(val) {
            this.selected = val
            // if (val.length == 1) {
            //     if (val[0].requestRepairState == 0) {
            //         this.maintenanceDis = false
            //         this.reminderDis = false
            //         this.finishDis = true
            //     } else if (val[0].requestRepairState == 1) {
            //         this.maintenanceDis = true
            //         this.reminderDis = true
            //         this.finishDis = false
            //     } else {
            //         this.maintenanceDis = true
            //         this.reminderDis = true
            //         this.finishDis = true
            //     }
            // } else {
            //     this.maintenanceDis = true
            //     this.reminderDis = true
            //     this.finishDis = true
            // }
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getRepairList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}